<div fxLayout="column" class="main-wrapper-core">
    <div class="header-wrap" fxLayoutAlign="space-between center" fxLayout="row">
        <span i18n class="title-label">Survey questions</span>
        <!-- <button mat-icon-button (click)="toggleQs()" matTooltip="show/hide questions" i18n-matTooltip>
            <mat-icon>expand_more</mat-icon>
        </button> -->
    </div>
    <div class="w-100">
        <app-resource-builder
            fxFlex="0 0 100%"
            #builderForm
            [resource]="resource"
            [language_id]="resourceForm?.get('language_id').value"
            [questionTypes]="questionTypes"
            [resource_type_id]="ResourceTypes.GeneralSurvey"
            [resourceType]="ResourceTypes.SURVEY"
            (saved)="$event && savingQuestions && submitResourceRegardlessQs()"
            [active]="bottomToolSheet"
            class="res-builder-column-layout w-100 m-10-0"
            [hideAddItems]="false"
            [ngClass]="{ 'rb-is-empty': isEmpty(resourceBuilder?.getService().getForm() | async) }"
        >
        </app-resource-builder>
    </div>
</div>
<ng-template #contentTemplateToBeInParent>
    <mat-expansion-panel #trailerExpansionPanel [expanded]="true" class="user-manage-course-expantion res-creat-manag">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>video_library</mat-icon>
                <div i18n>Trailer</div>
                <mat-icon
                    class="icon-explain"
                    matTooltip="Video presentation of this course presenting it with a trailer"
                    i18n-matTooltip
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <mat-icon
                    *ngIf="trailerExpansionPanel.expanded && videoLinkControl?.videoMedia"
                    class="md-24 remove-trailer"
                    (click)="$event.stopPropagation(); videoLinkControl.clearMedia()"
                    >delete_outline</mat-icon
                >
                <span
                    matTooltip="Indicator of field change"
                    i18n-matTooltip
                    class="cell-indicator"
                    [ngClass]="{ green: resourceForm.get('medias.trailer').dirty }"
                ></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <app-video-link-control
                class="trailer-uploader-wrapper"
                [formControl]="resourceForm.get('medias.trailer') | cast"
                [uploaderBtnLabel]="'Upload trailer'"
                i18n-uploaderBtnLabel="@@uploadTrailer"
                [resourceId]="resource?.id"
                [canRemoveMedia]="false"
            ></app-video-link-control>
        </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="true" class="user-manage-course-expantion res-creat-manag">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>display_settings</mat-icon>
                <div i18n>Default name</div>
                <mat-icon class="icon-explain" matTooltip="Default name of the survey to be displayed in the player"
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span matTooltip="Indicator of field change" i18n-matTooltip class="cell-indicator"></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <div fxLayoutGap="4px" fxLayout="row" class="w-50">
                <app-title-translation
                    type="title"
                    placeholder="Set default name"
                    i18n-placeholder
                    class="material-title-translation"
                    formControlName="labelTranslation"
                ></app-title-translation>
            </div>
        </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="true" class="user-manage-course-expantion res-creat-manag">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>fingerprint</mat-icon>
                <div i18n="@@SKU-ArticleNumber">SKU/ Article number</div>
                <mat-icon
                    class="icon-explain"
                    i18n-matTooltip
                    matTooltip="Article code is a unique field, autogenerated when empty."
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span matTooltip="Indicator of field change" i18n-matTooltip class="cell-indicator"></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <app-resource-article-code-form
                fxFlex="0 1 100%"
                formControlName="article_code"
                [resourceId]="resource?.id"
            ></app-resource-article-code-form>
        </ng-template>
    </mat-expansion-panel>
    <ng-container *ngIf="customFields$ | async as customFields">
        <ng-container *ngIf="customFields && customFields.length > 0">
            <app-resources-custom-fields
                [resource]="resource"
                [customFields]="customFields"
            ></app-resources-custom-fields>
        </ng-container>
    </ng-container>
</ng-template>
